export {LoaderService} from '@catmodules/common/ngx-http-loader/loader-service/services/loader.service';
export {LoaderComponent} from '@catmodules/common/ngx-http-loader/loader-service/components/loader/loader.component';



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_develop@2/app/Resources/Public/src/app/modules/base-app/services/index.ts